import apiServices from './apiServices'

export default class extends apiServices {
  // téléchargement du rapport
  static getLanguageOptions () {
    return this.get('/api/WebmasterTools/languageoptions')
  }
}
